import React from 'react';
import { Hero } from '../components/Hero';
import { FeatureGrid } from '../components/FeatureGrid';
import { HowItWorks } from '../components/HowItWorks';
import { PricingSection } from '../components/PricingSection';
import { ComparisonSection } from '../components/ComparisonSection';
import { TrustSection } from '../components/TrustSection';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-white" data-id="element-283">
      <Hero data-id="element-284" />
      <FeatureGrid data-id="element-285" />
      <HowItWorks data-id="element-286" />
      <PricingSection data-id="element-287" />
      <ComparisonSection data-id="element-288" />
      <TrustSection data-id="element-289" />
      <FAQSection data-id="element-290" />
      <CTASection data-id="element-291" />
      <Footer data-id="element-292" />
    </div>;
}